export const defaultConsignmentTemplate = (baseDate: Date = new Date()) => `{
  "consignor": {
    "commercialName": "ACME SARL"
  },
  "consignee": {
    "commercialName": "Retail Hub Paris"
  },
  "requestedStartTimeRange": {
    "earliestDateTime": "${baseDate.toISOString()}",
    "latestDateTime": "${new Date(baseDate.getTime() + 4 * 60 * 60 * 1000).toISOString()}"
  },
  "requestedEndTimeRange": {
    "earliestDateTime": "${new Date(baseDate.getTime() + 24 * 60 * 60 * 1000).toISOString()}",
    "latestDateTime": "${new Date(baseDate.getTime() + 36 * 60 * 60 * 1000).toISOString()}"
  },
  "originLocation": {
    "address": {
      "addressLocality": "Lyon",
      "postalCode": "69000",
      "addressCountry": {
        "countryCode": "FR",
        "countryName": "France"
      }
    }
  },
  "finalLocation": {
    "address": {
      "addressLocality": "Paris",
      "postalCode": "75015",
      "addressCountry": {
        "countryCode": "FR",
        "countryName": "France"
      }
    }
  },
  "consignmentDetails": [
    {
      "customerOrderLineId": "urn:bol:customer-order-line:line-001",
      "quantity": {
        "value": 24,
        "unit": "PCE"
      }
    }
  ],
  "services": [
    {
      "uri": "urn:bol:service:svc-001"
    }
  ],
  "weight": {
    "value": 980,
    "unit": "KGM"
  },
  "volume": {
    "value": 6.2,
    "unit": "MTQ"
  },
  "externalReferences": [
    {
      "externalReferenceType": "SELLER_ID",
      "reference": "CONS-2026-001"
    }
  ]
}`;
